import { Grid } from '@mui/material';
import { ChevronRight } from '@mui/icons-material';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Clock } from '~/Components/Icons';
import { Button, Typography } from '~/UIKit';
import { OpeningHoursSectionStyles } from '..';

export interface IOpeningHoursSectionTableCloseRowProps {
  currentDay: string;
  onOpenDayModal: (currentDay: string) => void;
}

export const OpeningHoursSectionTableCloseRow = ({
  currentDay,
  onOpenDayModal,
}: IOpeningHoursSectionTableCloseRowProps) => {
  const { t } = useTranslation();
  const { classes } = OpeningHoursSectionStyles();
  const handleOpenDayModal = () => {
    onOpenDayModal(currentDay);
  };
  return (
    <Grid container>
      <Grid
        className={classNames(classes.dayRow, classes.inactive, classes.hasBottomBorder)}
        alignItems="center"
        xs={6}
        container
      >
        <Grid className={classes.iconWrapper}>
          <Clock />
        </Grid>
        <span className={classes.itemRow}>{t(`app.weekdays.${currentDay}`)}</span>
      </Grid>
      <Grid xs={6} container className={classes.row}>
        <Grid
          data-testid="opening-hours-section-close-block"
          className={classNames(classes.inactive, classes.hasBottomBorder)}
          justifyContent="flex-end"
          alignItems="center"
          container
        >
          <Button variant="text" className={classes.timeButton} onClick={handleOpenDayModal}>
            <Typography className={classes.closeLabel}>{t('app.closed')}</Typography>
            <span className={classes.ChevronRight}>
              <ChevronRight />
            </span>
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};
